import { createGlobalStyle } from 'styled-components';
import { palette, font } from 'styled-theme';
// import 'antd/dist/antd.css';

const GlobalStyles = createGlobalStyle`
  .ant-btn{
    border-radius: 4px;
  }

  .ant-tooltip.ant-tooltip-placement-right{
    display: none;
    opacity: 0;
    pointer-event: none;
  }

  .header {
    display: flex;
    // justify-content: space-between;
    align-items: center;
  }

  .logo {
    font-size: 32px;
    font-weight: 700;
    color: #fff;
  }

  // for highlighting beta features

  .beta-func {
    border-radius: 20px;
    background: #6486EE;
    color: #fff;
    font-family: Nunito Sans;
    font-size: 10px;
    padding: 2px 10px;
    margin-left: 10px;
  }

  .ant-table-thead > tr.ant-table-row-hover:not(.ant-table-expanded-row) > td, .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row) > td, .ant-table-thead > tr:hover:not(.ant-table-expanded-row) > td, .ant-table-tbody > tr:hover:not(.ant-table-expanded-row) > td {
    background: #f8f8f8!important;
  }

  .ant-row.ant-form-item {
    margin-bottom: 5px;
  }

  .has-success.has-feedback {
    .ant-select {
      .ant-select-selection {
        .ant-select-selection__rendered {
          .ant-select-selection__placeholder {
            display: none !important;
          }
        }
      }
    }
  }

  .env-action {
    .ant-btn-default { 
        background-color: #132f44;
        color: #ffffff;
        font-family: Nunito Sans;
        font-size: 14px;
    }
        .ant-btn-default:not(:disabled):hover {
          color: #ffffff;
          border-color: #132f44;
          background: #132f44;
        }
  }

  /* =========================== YAML Dropdown ========================== */
    .yaml-dropdown {
      padding: 0 !important;
      border-bottom-left-radius: 0px !important;
      border-bottom-right-radius: 0px !important;
    }

   .yaml-dropdown .ant-dropdown-menu-item {
    padding: 0 !important;
  }

  .yaml-dropdown .yaml-revision-option {
    display: flex;
    flex-direction: column;
    gap: 6px;
    border-radius: 10px;
    font-family: Nunito Sans;
  }

  .yaml-dropdown .yaml-revision-option .yaml-revision-title {
    font-size: 14px;
    font-weight: 600;
    color: #1D2939;
  }

  .yaml-dropdown .yaml-revision-option .yaml-revision-meta {
    font-size: 12px;
    color: #667085;
  }

  .yaml-dropdown .yaml-revision-option .yaml-revision-detail {
    font-size: 12px;
    color: #98A2B3;
  }

  .yaml-dropdown .yaml-revision-option .yaml-revision-pill {
    font-size: 12px;
    font-weight: 600;
  }

  .yaml-dropdown .ant-dropdown-menu-item:hover .yaml-revision-option {
    background: rgba(19, 47, 68, 0.06);
  }

  .revision-dropdown-trigger {
    background: #132f44 !important;
    border: 1px solid #1c3b57 !important;
    color: #ffffff !important;
    font-family: Nunito Sans;
    font-size: 13px;
    font-weight: 600;
    height: 32px;
    border-radius: 8px;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    box-shadow: 0px 4px 12px rgba(19, 47, 68, 0.24);
    transition: all 0.2s ease;
  }

  .revision-dropdown-trigger:hover,
  .revision-dropdown-trigger:focus {
    background: #1c3b57 !important;
    border-color: #295173 !important;
    box-shadow: 0px 6px 16px rgba(19, 47, 68, 0.28);
    color: #ffffff !important;
  }

  .breadcrumb-class .ant-dropdown-menu-item {
    color: #a8b0b9 !important;
  }

  .breadcrumb-class .ant-dropdown-menu-item-selected {
    background: white !important;
    color: #4d99ef !important;
  }

  // .ant-breadcrumb .anticon {
  //   font-size: 3px;
  //   transform: scale(3, 2);
  //   vertical-align: middle;
  //   top: -2px;
  //   left: 3px;
  //   position: relative;
  // }

  /*=========================== Tabs style ============================*/

    // remove the separator for the last tab using nth of last type 2 as there is one more div appended by antd by default

    .tabs {

    .ant-tabs-nav-wrap {
      border-bottom: 0.5px solid #e7e7e7;
    }

    .ant-tabs-tab {
      min-width: 110px;
      display: flex;
      flexDirection: column;
      justify-content: center;
      align-items: center;
    }

    .ant-tabs-tab:not(:nth-last-of-type(2))::after {
      transform: translateX(20px);
      content: "|";
      position: absolute;
      right: 0;
      color: #ddd;
  }

  //changing the default and selected colour of tabs

  .ant-tabs-tab .ant-tabs-tab-btn {
    color: #A8B0B9 !important;
  }

  .ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #6486EE !important;
  }

.ant-tabs-ink-bar {
  background-color: #6486EE !important;
}
}

  /*-----------------------------------------------*/
  // style for project category menu [ScrumBoard]
  /*-----------------------------------------------*/
  .project-category {
    .ant-select-dropdown-menu {
      .ant-select-dropdown-menu-item {
        padding: 8px 12px;
        color: #000000;
        font-family: 'Poppins';
        font-weight: 400;
      }
    }
  }

  /*-----------------------------------------------*/
  // style for project menu [ScrumBoard]
  /*-----------------------------------------------*/

  &.customSelectDataSource{
    height: 40px;
    .ant-select-selector{
      height: 40px;
      display: flex;
      justify-content: start;
      align-items: center;
      width: 100%;
    }

    .ant-select-selection-item{
      display: flex;
      align-items: center;
      height: 40px;
      line-height: 40px !important;
    }

    .ant-select-selection-search .ant-select-selection-search-input{
      height: 38px;
    }
  }
  .ant-dropdown {
    &.project-menu {
      width: 280px;
      top: 133px !important;

      .ant-dropdown-menu {
        padding: 0;
        overflow: hidden;

        .ant-dropdown-menu-item {
          min-height: 54px;
          line-height: auto;
          display: flex;
          align-items: center;
          padding: 10px 20px;

          &:first-child {
            padding: 0;
            border-bottom: 1px solid #f4f6fd;

            &:hover,
            &:focus {
              background-color: #ffffff;
            }
          }

          &:hover,
          &:focus {
            background-color: #F3F5FD;
          }

          &:last-child {
            background-color: #E6EAF8;
          }
        }
      }
    }
  }

  /*-----------------------------------------------*/
  // style for popover [ScrumBoard]
  /*-----------------------------------------------*/
  .ant-popover {
    .ant-checkbox-group {
      display: flex;
      flex-direction: column;
      .ant-checkbox-group-item {
        margin: 5px 0;
        span {
          font-size: 14px;
          color: #788195;
          text-transform: capitalize;
        }
      }
    }
  }

  /*-----------------------------------------------*/
  // style for env var checkboxes
  /*-----------------------------------------------*/
  .ant-checkbox {
    align-self: start;
  }
  .env-vars-group {
    .ant-checkbox-wrapper {
      color: #1f1f1f;
      .ant-checkbox-checked {
        .ant-checkbox-inner {
          background-color: #132f44 !important;
          border-color: #132f44 !important;
        }
      }
    }
    .ant-checkbox-wrapper:hover {
      border: 1px solid #132f44 !important;
      .ant-checkbox-inner {
        border-color: #132f44;
      }
      .ant-checkbox-wrapper:not(.ant-checkbox-wrapper-disabled):hover .ant-checkbox-checked:not(.ant-checkbox-disabled):after {
          border-color: #132f44 !important;
      }
      .ant-checkbox-checked:after {
        border: 2px solid #132f44 !important;
      }
    }
  }

  /*-----------------------------------------------*/
  // style for modal [ScrumBoard]
  /*-----------------------------------------------*/
  .ant-modal-wrap {
    .ant-modal {
      .ant-modal-content {
        .ant-modal-body {
          .render-form-wrapper {
            padding: 10px;
            h2 {
              margin: 0;
            }
            form {
              padding: 15px 0 3px;
              .field-container {
                margin-bottom: 26px;
              }
            }
          }
        }
      }
    }
  }


/*-----------------------------------------------*/
  // style form previous GlobalStyles
  /*-----------------------------------------------*/

  .ant-table-thead > tr.ant-table-row-hover:not(.ant-table-expanded-row) > td, .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row) > td, .ant-table-thead > tr:hover:not(.ant-table-expanded-row) > td, .ant-table-tbody > tr:hover:not(.ant-table-expanded-row) > td {
    background: #f8f8f8!important;
}

font-family: ${font('primary', 0)};

h1,
h2,
h3,
h4,
h5,
h6,
a,
p,
li,
input,
textarea,
span,
div,
img,
svg {
  &::selection {
    background: ${palette('primary', 0)};
    color: #fff;
  }
}

.ant-row:not(.ant-form-item) {
  ${'' /* margin-left: -8px;
  margin-right: -8px; */};
  &:before,
  &:after {
    display: none;
  }
}

.ant-row > div {
  padding: 0;
}

.isoLeftRightComponent {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.isoCenterComponent {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
/********** Add Your Global CSS Here **********/

body {
  -webkit-overflow-scrolling: touch;
}

html h1,
html h2,
html h3,
html h4,
html h5,
html h6,
html a,
html p,
html li,
input,
textarea,
span,
div,
html,
body,
html a {
  margin-bottom: 0;
  font-family: 'Poppins';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.004);
}

html ul {
  -webkit-padding-start: 0px;
  list-style: none;
  margin-bottom: 0;
}

.scrollbar-track-y,
.scrollbar-thumb-y {
  width: 5px !important;
}

.scrollbar-track-x,
.scrollbar-thumb-x {
  height: 5px !important;
}

.scrollbar-thumb {
  border-radius: 0 !important;
}

.scrollbar-track {
  background: rgba(222, 222, 222, 0.15) !important;
}

.scrollbar-thumb {
  border-radius: 0 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.ant-popover-placement-bottom > .ant-popover-content > .ant-popover-arrow:after,
.ant-popover-placement-bottomLeft
  > .ant-popover-content
  > .ant-popover-arrow:after,
.ant-popover-placement-bottomRight
  > .ant-popover-content
  > .ant-popover-arrow:after,
.ant-popover-placement-top > .ant-popover-content > .ant-popover-arrow:after,
.ant-popover-placement-topLeft
  > .ant-popover-content
  > .ant-popover-arrow:after,
.ant-popover-placement-topRight
  > .ant-popover-content
  > .ant-popover-arrow:after {
  // left: 0;
  // margin-left: -4px;
}

/* Instagram Modal */

.ant-modal-wrap.instagram-modal .ant-modal {
  max-width: 935px;
  width: 100% !important;
}

@media only screen and (max-width: 991px) {
  .ant-modal-wrap.instagram-modal .ant-modal {
    padding: 0 60px;
  }
}

@media only screen and (max-width: 767px) {
  .ant-modal-wrap.instagram-modal .ant-modal {
    max-width: 580px;
  }
}

.ant-modal-wrap.instagram-modal .ant-modal-content {
  border-radius: 0;
}

.ant-modal-wrap.instagram-modal .ant-modal-content button.ant-modal-close {
  position: fixed;
  color: #fff;
}

.ant-modal-wrap.instagram-modal .ant-modal-content button.ant-modal-close i {
  font-size: 24px;
}

.ant-modal-wrap.instagram-modal .ant-modal-content .ant-modal-body {
  padding: 0;
}

/********** Add Your Global RTL CSS Here **********/

/* Popover */

html[dir='rtl'] .ant-popover {
  text-align: right;
}

/* Ecommerce Card */

html[dir='rtl'] .isoCardInfoForm .ant-input {
  text-align: right;
}

/* Modal */

html[dir='rtl'] .has-success.has-feedback:after,
html[dir='rtl'] .has-warning.has-feedback:after,
html[dir='rtl'] .has-error.has-feedback:after,
html[dir='rtl'] .is-validating.has-feedback:after {
  left: 0;
  right: auto;
}

html[dir='rtl'] .ant-modal-close {
  right: inherit;
  left: 0;
}

html[dir='rtl'] .ant-modal-footer {
  text-align: left;
}

html[dir='rtl'] .ant-modal-footer button + button {
  margin-left: 0;
  margin-right: 8px;
}

html[dir='rtl'] .ant-confirm-body .ant-confirm-content {
  margin-right: 42px;
}

html[dir='rtl'] .ant-btn > .anticon + span,
html[dir='rtl'] .ant-btn > span + .anticon {
  margin-right: 0.5em;
}

html[dir='rtl'] .ant-btn-loading span {
  margin-left: 0;
  margin-right: 0.5em;
}

html[dir='rtl']
  .ant-btn.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline) {
  padding-left: 25px;
  padding-right: 29px;
}

html[dir='rtl']
  .ant-btn.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline)
  .anticon {
  margin-right: -14px;
  margin-left: 0;
}

/* Confirm */

html[dir='rtl'] .ant-modal.ant-confirm .ant-confirm-body > .anticon {
  margin-left: 16px;
  margin-right: 0;
  float: right;
}

html[dir='rtl'] .ant-modal.ant-confirm .ant-confirm-btns {
  float: left;
}

html[dir='rtl'] .ant-modal.ant-confirm .ant-confirm-btns button + button {
  margin-right: 10px;
  margin-left: 0;
}

/* Message */

html[dir='rtl'] .ant-message .anticon {
  margin-left: 8px;
  margin-right: 0;
}

/* Pop Confirm */

html[dir='rtl'] .ant-popover-message-title {
  padding-right: 20px;
  padding-left: 0;
}

html[dir='rtl'] .ant-popover-buttons {
  text-align: left;
}

/* Notification */

html[dir='rtl']
  .ant-notification-notice-closable
  .ant-notification-notice-message {
  padding-left: 24px;
  padding-right: 0;
}

html[dir='rtl']
  .ant-notification-notice-with-icon
  .ant-notification-notice-message,
html[dir='rtl']
  .ant-notification-notice-with-icon
  .ant-notification-notice-description {
  margin-right: 48px;
}

html[dir='rtl'] .ant-notification-notice-close {
  right: auto;
  left: 16px;
}

html[dir='rtl'] .ant-notification-notice-with-icon {
  left: 0;
}
.ai-debug-btn {
    background-color: #4d99ef;
    border-radius: 5px;
    span {
      color: #ffffff;
      font-family: Nunito Sans;
      font-size: 12px;
      font-weight: 600;
    }
}

.ai-debug-btn:hover {
    background-color: #4d99ef !important;
}
    
.inner-load-container {
    .ant-spin-container {
      flex: 1;
      height: 100%;
      display: flex;
      flex-direction: column;
    }
    display: flex;
    flex-direction: column;
    height: 100%;
}

.outer-load-class {
    height: 100%;
    width: inherit;
    max-height: 100% !important;
}

/* Dropzone */

html[dir='rtl'] .dz-hidden-input {
  display: none;
}
`;

export default GlobalStyles;
